export class CalendarService {
  getCalendarList() {
    return ["Default Calendar", "Second Calendar", "Book Reading"];
  }
}
